'use client';

import { useMemo } from 'react';

import { Step, Stepper as TrilogyStepper } from '@bytel/trilogy-react';

import { useApp } from '@hooks/use-app';
import { useIsClient } from '@hooks/use-is-client';
import { useShouldShowOptionStep } from '@hooks/use-should-show-option-step';
import { useShouldShowPhoneStep } from '@hooks/use-should-show-phone-step';
import { useShouldShowProBillingStep } from '@hooks/use-should-show-pro-billing-step';

import { facturationRoute, optionRoute, phoneRoute, stepsRoutes } from '@helpers/routes';

export function Stepper() {
    const { pathname } = useApp();
    const isClient = useIsClient();

    const stepRoute = useMemo(() => stepsRoutes.find((s) => pathname.includes(s.path)), [pathname]);

    const shouldShowOptionStep = useShouldShowOptionStep(stepRoute);
    const shouldShowPhoneStep = useShouldShowPhoneStep(stepRoute);
    const shouldShowProBillingStep = useShouldShowProBillingStep();

    const stepsToShow = useMemo(() => {
        return stepsRoutes.filter((step) => {
            if (step.path === optionRoute.path) {
                // Hide only when explicitly false
                return shouldShowOptionStep !== false;
            }
            if (step.path === phoneRoute.path) {
                // Hide only when explicitly false
                return shouldShowPhoneStep !== false;
            }
            if (step.path === facturationRoute.path) {
                return shouldShowProBillingStep;
            }
            return true;
        });
    }, [shouldShowOptionStep, shouldShowPhoneStep, shouldShowProBillingStep]);

    if (!isClient) return null;

    return (
        <>
            <TrilogyStepper>
                {stepsToShow.map((step) => (
                    <Step
                        key={step.path}
                        label={step.title}
                        current={stepRoute?.step === step.step}
                        done={stepRoute ? stepRoute.step > step.step : false}
                    />
                ))}
            </TrilogyStepper>
        </>
    );
}
